export default "__VITE_ASSET__1efb67f2__"